module.exports = __webpack_public_path__ + "img/kite-logo.2b51daeb.png";